import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, Subscription, firstValueFrom } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { IntegrationsStatus, MMap, MMapIdea } from 'src/app/model/mindmeister.model';
import { TodoItemNode } from 'src/app/model/notes.model';
import { LocalDatabaseService } from 'src/app/services/firestore/local-database.service';
import { MindmeisterService } from 'src/app/services/api/mindmeister.service';

import * as JSZip from 'jszip';
import { AuthService } from 'src/app/services/authentication/auth.service';
import {doc, Firestore, getFirestore} from 'firebase/firestore';
//import {docData} from '@angular/fire/firestore';
import { docData } from '../../utils/custom-firestore.utils';
import { XMindService } from 'src/app/services/api/xmind.service';
import { FreeplaneService } from 'src/app/services/api/freeplane.service';
import { FormattingService } from 'src/app/services/utilites/formatting.service';

@Component({
  selector: 'app-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./dialog.scss']
})
export class ExportDialogComponent implements OnInit {

  viewMode: 'settings' | 'exporting' | 'success' | 'fail' = 'settings';
  status: 'fail' | 'success';
  exportedURL = '';
  failMessage = '';

  //data: string;
  exportLocation: 'file' | 'mindmeister' | 'xmind' = 'xmind';
  exportLocationMindmeister: 'new' | 'existing' = 'new';

  myControlMM = new UntypedFormControl();
  mindMapList: MMap[] = [];
  filteredMaps: Observable<MMap[]>;
  mmSelected: MMap = null;
  //mmSelectedValue = '';

  myControlMMIdea = new UntypedFormControl();
  mindMapIdeas: MMapIdea[] = [];
  filteredIdeas: Observable<MMapIdea[]>;
  mmIdeaSelected: MMapIdea = null;
  //mmIdeaSelectedValue = '';

  nodesToExport: TodoItemNode = null;

  loadingMindMaps = false;
  loadingMindMapIdeas = false;
  mindMapsLoaded = false;

  placeHolderMM: string = 'Loading Mind Maps...'

  error = "";

  integrationsStatus : IntegrationsStatus = null;
  integrationsStatusObservable: Observable<IntegrationsStatus>;
  integratioStatusSubscription: Subscription = null;

  private firestore: Firestore = getFirestore();


  public urls = [
    'https://i.imgur.com/R4gpt2H_d.webp',
    'https://i.imgur.com/BevyDwM_d.webp',
    'https://i.imgur.com/pHMY26k_d.webp'
  ];

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private cdRef: ChangeDetectorRef,
    public dialogRef: MatDialogRef<ExportDialogComponent>,
    public mindmeisterService: MindmeisterService,
    private _database: LocalDatabaseService,
    private authService: AuthService,
    private xmindService: XMindService,
    private freePlaneService: FreeplaneService,
    private formattingService: FormattingService
   ) { }

  scrollToBottom(): void {
    console.log("scroll to bottom, export location = " + this.exportLocationMindmeister);
    /*setTimeout(() => {
      const contentElement = this.el.nativeElement.querySelector('.content-export');
       this.renderer.setProperty(contentElement, 'scrollTop', contentElement.scrollHeight);
    }, 1000);*/

    this.cdRef.detectChanges();

    const contentElement = this.el.nativeElement.querySelector('.content-export');
    this.renderer.setProperty(contentElement, 'scrollTop', contentElement.scrollHeight);
  }

  exportToNewMeindMeisterMap() {
    this.dialogRef.disableClose = true;
    this.viewMode = 'exporting';

    this.mindmeisterService.addMap(this._database.exportFromNode.item)
      .subscribe(
        responseData => {
          //console.log((<RespNewIdea> responseData).rsp.id);
          this.mindmeisterService.rootMindmeisterIdeaExported = responseData.rsp.map.id;

          console.log("Novo mindmap criado, map id = " + responseData.rsp.map.id);
          console.log("Novo mindmap criado, title = " + responseData.rsp.map.title);

          // TODO fazer o export aqui --
          this.mindmeisterService.getNodesToExport().then(async result => {
            this.nodesToExport = result
            console.log("Pegou tudo -- uauau");
            await this.mindmeisterService.exportNodesToNewMindMeisterMAp(this.nodesToExport, responseData.rsp.map.id, responseData.rsp.map.id);
            this.viewMode = 'success';
            this.dialogRef.disableClose = false;
            this.mindmeisterService.clearProgressCounters();
            //[nao precisa] - TODO colocar TRY/CATCH - ou testa se promisse nao lança erro e pega no catch abaixo q colcará abaixo.
            // no catch pegou o erro do await
          }).catch(error => {
            this.failMessage = 'Unable to export notes to the created mindmap';
            this.viewMode = 'fail';
            console.log("Opss error: " + error.message);
          }); // faz o then -- pegar erro - UX  e progress

        },
        error => {
          console.log('Entrou aqui no erro de fail');
          this.failMessage = 'Unable to create mindmap';
          this.viewMode = 'fail';

          console.log(error.message);
        }
      );
  }

  exportToExistingMeindMeisterMap() {

    if (!this.mmSelected || !this.mmSelected.id) {
      this.error = 'Please select a mind map';
      return;
    }

    this.dialogRef.disableClose = true;
    this.viewMode = 'exporting';

    this.mindmeisterService.getNodesToExport().then(async result => {
      this.nodesToExport = result
      console.log("Pegou tudo -- uauau");
      await this.mindmeisterService.exportNodesToMindMeister(this.nodesToExport, this.mmSelected.id,
        (this.mmIdeaSelected && this.mmIdeaSelected.id) ? this.mmIdeaSelected.id : this.mmSelected.id);
      this.viewMode = 'success';
      this.dialogRef.disableClose = false;
      this.mindmeisterService.clearProgressCounters();

      //[nao precisa] - TODO colocar TRY/CATCH - ou testa se promisse nao lança erro e pega no catch abaixo q colcará abaixo.
      // mas la quanto mada imagem ou dentro do subcribe se da erro, nao cai aqui o erro, azar deixa assim mesmo por enquanto

    }).catch(error => {
      console.log("Opss error: " + error.message);
      console.log("ALL error: ", error);
      this.failMessage = 'Unable to export notes to the selected mindmap';
      this.viewMode = 'fail';
    }); // faz o then -- pegar erro - UX  e progress; // pega a partir dos selecionados
  }

  exportToAFile() {
    // https://stackoverflow.com/questions/21012580/is-it-possible-to-write-data-to-file-using-only-javascript
    // https://acclaim.agency/blog/download-many-files-by-automatically-generated-zip-file
    // google search: https://www.google.com/search?q=javascript+generate+zip+file+to+download&ei=z300Y-THL5D01sQPmvmjqAo&ved=0ahUKEwik6-6l-7f6AhUQupUCHZr8CKUQ4dUDCA4&uact=5&oq=javascript+generate+zip+file+to+download&gs_lcp=Cgdnd3Mtd2l6EAMyBQgAEKIEMgUIABCiBDIFCAAQogQyBQgAEKIEMgUIABCiBDoKCAAQRxDWBBCwAzoGCAAQDRATOgoIABAeEAgQDRATOgoIIRDDBBAKEKABSgQIQRgASgQIRhgAUNsHWKkwYNIyaAFwAXgAgAGxAYgBpQ2SAQQwLjEymAEAoAEByAEIwAEB&sclient=gws-wiz

    // How to Create ZIP Files in Javascript Using JSZIP Library and FileSaver.js Library Full Tutorial
    // https://www.youtube.com/watch?v=RidCPO23cOM

    //Angular 13 JSZip Example to Download & Compress Multiple Files into a ZIP File in TypeScript
    //https://www.youtube.com/watch?v=9WRtHAeq4FE
    //https://codingshiksha.com/angular/angular-13-jszip-example-to-download-compress-multiple-files-into-a-zip-file-in-browser-using-typescript/

    //Better
    //https://stuk.github.io/jszip/


    //https://www.angularfix.com/2022/05/angular-11-to-add-files-zip-using-jszip.html

    //Xmind
    //https://en.wikipedia.org/wiki/XMind#:~:text=The%20.xmind%20file%20format%20implementing,on%20some%20principles%20of%20OpenDocument.
    //.zip(xmind)

    this.dialogRef.disableClose = true;
    this.viewMode = 'exporting';

    this.mindmeisterService.getNodesToExport().then(async result => {
      this.nodesToExport = result
      const name = this.nodesToExport.item.substring(0, Math.min(30, this.nodesToExport.item.length));

      let count = 0;
      const zip = new JSZip();
      let hasImage = false;
      let img: JSZip;

      let mmContent = `<map version="1.0.1">\n`;

      mmContent = mmContent.concat(`<node ID="${this.nodesToExport.id}"  TEXT="${this.nodesToExport.item}">\n`);

      function runTree(node: TodoItemNode) {
        mmContent = mmContent.concat(`<node ID="${node.id}"  TEXT="${node.item}">\n`);

        if (node.file) {
          if (!hasImage) {
            img = zip.folder("images");
            hasImage = true;
          }

          img.file(`${node.id}.png`, node.file);

          mmContent = mmContent.concat(`<richcontent TYPE="NODE"><html><head></head><body><p>${node.item}</p><img src="images/${node.id}.png"/></body></html></richcontent>`);
        }

        if (node.children) {
          node.children.forEach(node => {
            runTree(node);
          });
        }

        mmContent = mmContent.concat(`</node>\n`);
      }

      if (this.nodesToExport.children) {
        this.nodesToExport.children.forEach(node => {
          runTree(node);
        });
      }


      // problema com & comercial ao exportar, nao reconhece no mm

      mmContent = mmContent.concat(`</node>\n</map>\n`);

      // #1 Ver exemplo de arquivo exportado pelo mindmeister
      //[] - TODO - varre e adidiona os nodos para o .mm
      //  -- barbadinha
      //zip.file("Hello.txt", "Hello World\n");
      zip.file(`${this.nodesToExport.item}.mm`, mmContent);

      //[] - TODO -  faz o zip das imagens
      // - barbadinha
      zip.generateAsync({ type: 'blob' }).then((content) => {
        const objectUrl: string = URL.createObjectURL(content);
        const link: any = document.createElement('a');

        link.download = `${name}.zip`;
        link.href = objectUrl;
        link.click();
      });

      this.viewMode = 'success';
      this.dialogRef.disableClose = false;
      this.dialogRef.close();

      //[nao precisa] - TODO colocar TRY/CATCH - ou testa se promisse nao lança erro e pega no catch abaixo q colcará abaixo.
      // mas la quanto mada imagem ou dentro do subcribe se da erro, nao cai aqui o erro, azar deixa assim mesmo por enquanto

    }).catch(error => {
      this.failMessage = 'Unable to export notes to the selected mindmap';
      this.viewMode = 'fail';
    }); // faz o then -- pegar erro - UX  e progress; // pega a partir dos selecionados



    /* zip.file("Hello.txt", "Hello World\n");
     var img = zip.folder("images");
     img.file("smile.gif", imgData, {base64: true});
     zip.generateAsync({type:"blob"})
     .then(function(content) {
     // see FileSaver.js
           saveAs(content, "example.zip");
     });*/



    /*this.urls.forEach((url) => {
      const filename = url.split('/')[url.split('/').length - 1];

      JSZipUtils.getBinaryContent(url, (err, data) => {
        if (err) {
          throw err;
        }

        zip.file(filename, data, {binary: true});
        count++;

        if (count === this.urls.length) {
          zip.generateAsync({type: 'blob'}).then((content) => {
            const objectUrl: string = URL.createObjectURL(content);
            const link: any = document.createElement('a');

            link.download = 'sample-pdf-files.zip';
            link.href = objectUrl;
            link.click();
          });
        }
      });
    });*/

  }

  async exportToFreePlaneFile() {

    this.dialogRef.disableClose = true;
    this.viewMode = 'exporting';

    try {
      const result = await this.mindmeisterService.getNodesToExport();
      this.nodesToExport = result;

      // -- 1) Sanitiza o título (para usar como base do nome do zip e do .mm)
      const rawName = this.nodesToExport.item;
      const safeName = this.formattingService.sanitizeFilename(rawName, 50);  // p.ex, 50 chars no máximo

      let count = 0;
      const zip = new JSZip();
      let hasImage = false;
      let img: JSZip;
      const uptime = Date.now();

      // Função de escape (pode ficar fora se preferir)
      const escapeXml = (value: string | null | undefined): string => {
        if (value === null || value === undefined) return '';
        return value
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&apos;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      };

      let mmContent = `<map version="freeplane 1.12.1">\n<!--To view this file, download free mind mapping software Freeplane from https://www.freeplane.org -->\n`;

      mmContent = mmContent.concat(`<node TEXT="${escapeXml(this.nodesToExport.item)}" LOCALIZED_STYLE_REF="AutomaticLayout.level.root" FOLDED="false" ID="${this.nodesToExport.id}"  CREATED="${uptime}" MODIFIED="${uptime}" CHILD_NODES_LAYOUT="TOPTOBOTTOM_RIGHT_AUTO" >\n`);

      mmContent = mmContent.concat(this.freePlaneService.generateLightNordStyle());


      // === Função recursiva para inserir nós ===
      /**
       * @param node O nó atual a exportar
       * @param depth Nível de profundidade (0 = raiz, 1 = filhos do raiz, etc.)
       * @param index Índice do nó entre os irmãos no mesmo nível
       */
      async function runTree(node: TodoItemNode, depth: number, index: number) {
        // Escapa texto e ID
        //const safeItem = this.freePlaneService.escapeXml(node.item);
        const safeItem = escapeXml(node.item);

        // *** POSIÇÃO ***: Só define POSITION se depth == 1 (ou seja, filhos diretos do raiz)
        // e vamos alternar entre bottom_or_right (par) e top_or_left (ímpar).
        let positionAttr = '';
        if (depth === 1) {
          positionAttr = (index % 2 === 0) ? 'bottom_or_right' : 'top_or_left';
        }

        // Monta a tag do nó, acrescentando POSITION se houver
        mmContent += `<node TEXT="${safeItem}" ID="${node.id}"`;
        if (positionAttr) {
          mmContent += ` POSITION="${positionAttr}"`;
        }
        mmContent += ` CREATED="${uptime}" MODIFIED="${uptime}">\n`;

        if (node.file) {
          if (!hasImage) {
            img = zip.folder("images");
            hasImage = true;
          }

          // 1) Lê a dimensão do arquivo
          const { width } = await FormattingService.getImageDimensions(node.file);

          // 2) Calcula ratio para limitar a 300px de largura
          //    Se não quiser "aumentar" imagens pequenas, faça ratio <= 1.0
          let ratio = 1.0;
          if (width > 400) {
            ratio = 400 / width; // ex.: se width=600 -> ratio=0.5
          }

          // 3) Adiciona arquivo no ZIP
          const imageFileName = `${node.id}.png`;
          img.file(imageFileName, node.file);

          //mmContent = mmContent.concat(`<hook URI="images/${imageFileName}" SIZE="0.2" NAME="ExternalObject"/>`);
          // 4) Escreve o hook com SIZE
          //    Exemplo: <hook URI="images/abc123.png" SIZE="0.5" NAME="ExternalObject"/>
          mmContent += `<hook URI="images/${imageFileName}" SIZE="${ratio.toFixed(3)}" NAME="ExternalObject"/>`;

        }

         // Chama recursivamente para os filhos
        if (node.children) {
          // Para iterar de modo assíncrono, use for-of + await:
          for (let i = 0; i < node.children.length; i++) {
            await runTree(node.children[i], depth + 1, i);
          }
        }

        mmContent = mmContent.concat(`</node>\n`);
      }

      // Percorre os filhos do nó raiz (depth = 1)
      if (this.nodesToExport.children) {
        // Chamamos runTree para cada child
        for (let i = 0; i < this.nodesToExport.children.length; i++) {
          await runTree(this.nodesToExport.children[i], 1, i);
      }
      }


      // problema com & comercial ao exportar, nao reconhece no mm

      mmContent = mmContent.concat(`</node>\n</map>\n`);

      zip.file(`${safeName}.mm`, mmContent);

      zip.generateAsync({ type: 'blob' }).then((content) => {
        const objectUrl: string = URL.createObjectURL(content);
        const link: any = document.createElement('a');

        link.download = `${safeName}.zip`;
        link.href = objectUrl;
        link.click();
      });

      this.viewMode = 'success';
      this.dialogRef.disableClose = false;
      this.dialogRef.close();

    } catch(error) {
      this.failMessage = 'Unable to export notes to the selected mindmap: ' + error?.message;
      this.viewMode = 'fail';
    };

  }

  export() {

    this.error = '';

    if ((this.exportLocation == 'mindmeister') && (this.exportLocationMindmeister == 'new')) {
      this.exportToNewMeindMeisterMap();
    } else if ((this.exportLocation == 'mindmeister') && (this.exportLocationMindmeister == 'existing')) {
      this.exportToExistingMeindMeisterMap();
    } else if (this.exportLocation == 'file') {
      this.exportToFreePlaneFile();
    } else if (this.exportLocation == 'xmind') {
      this.exportToXmindFile();
    }
  }

  async ngOnInit(): Promise<void> {
    this.filteredMaps = this.myControlMM.valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.title)),
      map(title => (title ? this._filterMM(title) : this.mindMapList.slice())),
    )

    const user = await firstValueFrom(this.authService.user$);

    this.integrationsStatusObservable = docData(
      doc(
        this.firestore,
        `users/${user.uid}/integrations/integrations_status`
      )
    ) as Observable<IntegrationsStatus>;

    this.integratioStatusSubscription = this.integrationsStatusObservable.subscribe( data => {
      this.integrationsStatus = data;
    } );

  }

  ngOnDestroy(): void {
    this.integratioStatusSubscription.unsubscribe();
  }

  isMindMeisterConnected() {
    if (this.integrationsStatus && this.integrationsStatus.mindmeisterIsConnected)
      return true;

    return false;
  }

  getMindMeisterMaps() {

    if (this.mindMapsLoaded)
      return;

    this.loadingMindMaps = true;

    this.mindmeisterService.getMapsList().then(a => {
      console.log("resultado after tehn");
      console.log(a);
      this.mindMapList = <MMap[]> a;

      this.placeHolderMM = 'Mind Map';

      this.filteredMaps = this.myControlMM.valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value.title)),
        map(title => (title ? this._filterMM(title) : this.mindMapList.slice())),
      )

      this.loadingMindMaps = false;
      this.mindMapsLoaded = true;

    }).catch (error => {
      console.log("error: ", error);
      this.placeHolderMM = 'Unable to load MindMaps';
      this.loadingMindMaps = false;
    });
  }

  private _filterMM(value: string): MMap[] {
    const filterValue = value.toLowerCase()
    return this.mindMapList.filter(option =>
      option.title.toLowerCase().includes(filterValue)
    )
  }

  OnMMSelected(mmSelected: MMap) {
    console.log(mmSelected);
    this.mmSelected = mmSelected;

    this.error = '';

    // buscar por ideas

    this.scrollToBottom();

    this.loadingMindMapIdeas = true;

    this.mindmeisterService.getMapIdeas(this.mmSelected.id).then(a => {
      console.log("resultado after tehn");
      console.log(a);

      this.mindMapIdeas = <MMapIdea[]> a;

      this.filteredIdeas = this.myControlMMIdea.valueChanges.pipe(
        startWith(''),
        map(value => (typeof value === 'string' ? value : value.title)),
        map(title => (title ? this._filterMMIdeas(title) : this.mindMapIdeas.slice())),
      )

      this.loadingMindMapIdeas = false;

    }).catch (error => {
      this.loadingMindMapIdeas = false;
      console.log("error: ", error);

    });

  }

  displayMMFn(option: MMap) {
    return (option && option.title) ? option.title : '';
  }


  /** Mindmap Idea autocomplete */

  private _filterMMIdeas(value: string): MMapIdea[] {
    const filterValue = value.toLowerCase()
    return this.mindMapIdeas.filter(option =>
      option.title.toLowerCase().includes(filterValue)
    )
  }

  OnMMIdeaSelected(mmIdeaSelected: MMapIdea) {
    console.log(mmIdeaSelected);
    this.mmIdeaSelected = mmIdeaSelected;
  }

  displayMMIdeaFn(option: MMapIdea) {
    return (option && option.title) ? option.title : '';
  }

  clearSelectedIdea() {
    this.mmIdeaSelected = null;
    this.myControlMMIdea.setValue('');
  }

  clearSelectedMindMap(field, input) {
    this.mmSelected=null;
    this.myControlMM.setValue('');
    //this.mmSelectedValue='';
    //this.myControlMM.un  .classList.remove('mat-focused' )
    //this.myControlMM.d
    //https://stackoverflow.com/questions/50771298/remove-focus-blur-on-select-programmatically-angular6-material
    //field._elementRef.nativeElement.classList.remove('mat-focused');
    //input._elementRef.nativeElement.classList.remove('mat-focused');
    //input.blur();

    //field.focused = false;
    //input.focused = false;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }


  /**
   * Trigger the export of notes to a .xmind file.
   */
  exportToXmindFile() {
    //const rootNode: TodoItemNode = this.getRootNode();

    this.dialogRef.disableClose = true;
    this.viewMode = 'exporting';

    this.mindmeisterService.getNodesToExport().then(async result => {
      this.nodesToExport = result;
      //const name = this.nodesToExport.item.substring(0, Math.min(30, this.nodesToExport.item.length));

      const rawName = this.nodesToExport.item;
      const name = this.formattingService.sanitizeFilename(rawName, 50);  // p.ex, 50 chars no máximo

      try {
        const url = await this.xmindService.exportToXMind(this.nodesToExport);

        const link: any = document.createElement('a');

        link.download = name + '.xmind';
        link.href = url;
        link.click();

        this.viewMode = 'success';
        this.dialogRef.disableClose = false;
        this.dialogRef.close();

      } catch (error) {
        console.log(error);
        throw error;
      }

    }).catch((error) => {
      this.failMessage = 'Unable to export notes to the selected mindmap';
      this.viewMode = 'fail';
    }); //



  }



  // Routing to Angular Material Dialogs
  // https://medium.com/ngconf/routing-to-angular-material-dialogs-c3fb7231c177

  // https://stackblitz.com/edit/multiple-dialogs-so-euvvlc?file=app%2Fapp.component.ts

  // https://www.youtube.com/watch?v=AivsEBpOGJw

  //https://www.positronx.io/angular-8-modal-tutorial-with-angular-material-dialog/

}
function saveAs(content: Blob, arg1: string) {
  throw new Error('Function not implemented.');
}



